import React, { Component } from 'react'

class CloseButton extends Component {
    render() {
        return (
            <button className="btn close-dialog-btn" onClick={() => this.props.action()}>Close</button>
        )
    }
}

export default CloseButton



// WEBPACK FOOTER //
// ./src/components/modal/CloseButton.js